const ResultsList = ({ results, selectedItem, onSelectItem }) => {
  if (!results || !Array.isArray(results?.items) || results?.items?.length === 0) return null;

  return (
    <div className="border border-gray-300 rounded overflow-hidden mb-4">
      <div className="bg-gray-100 border-b border-gray-300 px-4 py-2">
        <span className="text-sm font-bold">Available {results.itemType === 'show' ? 'Shows' : 'Episodes'}</span>
      </div>
      <div className="bg-white max-h-64 overflow-y-auto">
        {results.items.map((item) => (
          <button
            key={item.id || item.value}
            onClick={() => onSelectItem(item)}
            className={`w-full text-left px-4 py-3 border-b border-gray-300 last:border-b-0 hover:bg-gray-100 transition flex items-center gap-2 ${
              selectedItem?.id === item.id ? 'bg-blue-200 font-semibold' : ''
            }`}
          >
            {/* {item.thumbnail && (
              <img 
                src={item.thumbnail} 
                alt={item.name || item.label}
                className="w-8 h-8 rounded object-cover"
                //onError={(e) => e.target.style.display = 'none'}
              />
            )} */}
            <span>{item.name || item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};


export default ResultsList;